import { PersonPostionGroup } from '@aibees/elephant/feature/search-table-people';

export function useIsCurrentJob(item: PersonPostionGroup) {
  return !item.date?.end;
}
